import React, { FC, memo } from 'react';
import { Box } from '@material-ui/core';
import summaryStyles from '../../../../summary/summarySection/SummaryStyles';
import FeatureCategoryTitle from '../../../../featureCategories/featureCategoryTitle/FeatureCategoryTitle';
import SelectedOption from './selectedFeatureOption/SelectedOption';
import ICategory from '../../../../../../../model/ICategory';
import IFeature from '../../../../../../../model/IFeature';

export interface ISelectedFeatureCategoryListProps {
  categories: ICategory[];
  sectionName: string;
  sectionCode: string;
  sectionDisclaimerIndicative?: string;
  sectionFeatures?: IFeature[];
}

const SelectedFeatureCategoryList: FC<ISelectedFeatureCategoryListProps> = memo(
  ({ categories, sectionName, sectionCode, sectionDisclaimerIndicative, sectionFeatures }) => {
    const styles = summaryStyles();

    return (
      <Box className={styles.selectionContainer} data-test={`summary_expanded:section:${sectionCode}`}>
        <FeatureCategoryTitle
          name={sectionName}
          code={sectionCode}
          classes={{ title: styles.selectedFeaturesCategoryTitle, indicativeNumber: styles.indicativeNumber }}
          isSummary={true}
          disclaimerIndicative={sectionDisclaimerIndicative}
        />
        {categories?.map((category, k) => (
          <Box key={k}>
            <FeatureCategoryTitle
              name={category.name}
              classes={{ title: styles.selectedFeaturesSubcategoryTitle }}
              isSummary={true}
            />
            {category.featuresList?.features.map((feature, index) => (
              <SelectedOption
                sectionCode={sectionCode}
                feature={feature}
                sectionType={category.attributes?.selectiontype}
                key={index}
              />
            ))}
          </Box>
        ))}
        {sectionFeatures?.map((feature, index) => (
          <SelectedOption sectionCode={sectionCode} feature={feature} key={index} />
        ))}
      </Box>
    );
  },
);

export default SelectedFeatureCategoryList;
